export const SELECT_IMAGE = 'insertImage/SELECT_IMAGE';
export const RESET_SELECTED_IMAGES = 'insertImage/RESET_SELECTED_IMAGES';
export const UPLOAD_NEW_IMAGES = 'insertImage/UPLOAD_NEW_IMAGES';
export const UPLOAD_NEW_IMAGES_REQUEST = 'insertImage/UPLOAD_NEW_IMAGES_REQUEST';
export const UPLOAD_NEW_IMAGES_SUCCESS = 'insertImage/UPLOAD_NEW_IMAGES_SUCCESS';
export const UPLOAD_NEW_IMAGES_FAILURE = 'insertImage/UPLOAD_NEW_IMAGES_FAILURE';
